<template>
  <div class="page-header">
    <div class="header-content">
      <div class="back-btn" @click="toBack">
        <i class="el-icon-arrow-left"></i>
        <span>返回</span>
      </div>
      <div class="page-title">{{ title }}</div>
    </div>
  </div>
</template>

<script>
export default {
  name: "NavHeader",
  props: {
    title: {
      type: String,
      default: ""
    }
  },
  methods: {
    toBack() {
      this.$router.go(-1);
    }
  }
};
</script>

<style lang="scss" scoped>
.page-header {
  background: #fff;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.05);
  border-bottom: 1px solid #e6e8eb;

  .header-content {
    display: flex;
    align-items: center;
    padding: 12px 20px;

    .back-btn {
      display: flex;
      align-items: center;
      color: #606266;
      cursor: pointer;
      transition: color 0.3s;

      &:hover {
        color: var(--color-primary);
      }

      i {
        margin-right: 4px;
      }
    }

    .page-title {
      flex: 1;
      text-align: center;
      font-size: 18px;
      font-weight: 600;
      color: #303133;
    }
  }
}
</style>
